import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { Form, FormInput } from '../core/Formikfy';
import { Alert } from '@material-ui/lab';
import { useStyles } from './styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Avatar from '@material-ui/core/Avatar';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import { useAuth } from '../contexts/AuthContext';
import Fade from '@material-ui/core/Fade';
import { Card } from '../components/Card/Card';
import { CardHeader } from '../components/Card/CardHeader';
import { CardBody } from '../components/Card/CardBody';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { CardFooter } from '../components/Card/CardFooter';

export const ForgotPassword = () => {
  const classes = useStyles();
  const { resetPassword } = useAuth();
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  return (
    <Grid container component="main" className={classes.container}>
      <Grid item xs={10} sm={8} md={6} lg={3}>
        <Fade in={checked}>
          <Card>
            <CardHeader>
              <Avatar className={classes.avatar}>
                <VpnKeyOutlinedIcon fontSize="small" />
              </Avatar>
              <Typography
                variant="h6"
                style={{
                  color: 'white',
                  fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
                  marginTop: '20px',
                }}
              >
                Reset Password
              </Typography>
            </CardHeader>
            <CardBody>
              <Form
                className={classes.form}
                initialValues={{
                  email: '',
                }}
                onSubmit={async (data) => {
                  try {
                    setLoading(true);
                    await resetPassword(data.email);
                    setMessage('Check your inbox for further instructions');
                  } catch (error) {
                    setMessage(error);
                  }
                  setLoading(false);
                  setShowAlert(true);
                }}
              >
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <AccountCircleOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="email"
                      label="Email"
                      name="email"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                {showAlert && <Alert severity="error">{message}</Alert>}
                <Button
                  disabled={loading}
                  type="submit"
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Reset Password
                </Button>
              </Form>
            </CardBody>
            <CardFooter>
              <Grid container>
                <Grid item xs></Grid>
                <Grid item>
                  <Link href="/login">{'<< Go back to Login'}</Link>
                </Grid>
              </Grid>
            </CardFooter>
          </Card>
        </Fade>
      </Grid>
    </Grid>
  );
};
